import { groupBy } from "../analytics/engine/groupBy";
import { computeTrend } from "../analytics/engine/trend";

const DEFAULT_TOP = 8;

// Normalizes a chat-requested chart spec into a uniform
// { chartType, xKey:'label', yKey:'value', data, ... } shape. Charts belong
// to the conversation (per product architecture) — there is no "default
// dashboard chart" anymore, only ones the user actually asked for.
export function buildChartFromSpec(dataset, spec = {}) {

  const {
    chartType = "bar",
    dimension,
    measure,
    aggregation = "sum",
    dateColumn,
    period = "year",
    top = DEFAULT_TOP,
  } = spec;

  if (!Array.isArray(dataset) || !dataset.length) {
    return { success: false, error: "No data available to chart." };
  }

  // Time-series path: aggregate by period along a date column.
  if (dateColumn) {

    const trend = computeTrend(dataset, { dateColumn, measure, period, aggregation });

    if (!trend.success) {
      return { success: false, error: trend.error || "Could not build trend chart." };
    }

    return {
      success: true,
      tool: "chart",
      chartType: chartType === "bar" ? "bar" : "line", // time series defaults to line unless bar explicitly asked
      xKey: "label",
      yKey: "value",
      data: trend.series.map(p => ({ label: p.period, value: p.value })),
      measure,
      dateColumn,
      period,
      aggregation,
    };
  }

  // Categorical path: group by a dimension.
  if (dimension) {

    let grouped = groupBy(dataset, dimension, measure, aggregation);

    grouped = grouped
      .filter(g => g.value !== null)
      .sort((a, b) => b.value - a.value)
      .slice(0, top);

    if (!grouped.length) {
      return { success: false, error: `No usable data to chart for ${dimension}.` };
    }

    return {
      success: true,
      tool: "chart",
      chartType,
      xKey: "label",
      yKey: "value",
      data: grouped.map(g => ({ label: String(g.group), value: g.value })),
      measure,
      dimension,
      aggregation,
    };
  }

  return { success: false, error: "A chart needs either a dimension or a date column." };
}
